export default {"src":"/_next/static/media/mail-forward.04382f39.svg","height":96,"width":96};